import { shopsBasicFilaRapida } from "../../data/shops"

const defaultShop = shopsBasicFilaRapida.find(shop => !shop.disabled) || { value: '', name: '', disabled: false }

const defaultState = {
  test: {
    name: 'fila rápida',
    shops: shopsBasicFilaRapida.map(shop => ({ ...shop, disabled: false }))
  },
  shop: {
    ...defaultShop,
    disabled: false
  },
}


// Este reducer es solo para la autorización que se está gestionando
const autorizacionReducer = (state = { ...defaultState }, { type, payload }) => {
  switch (type) {
    case 'UPDATE_AUTORIZACION':
      sessionStorage.setItem('autorizacion', JSON.stringify({ ...state, ...payload }))
      return { ...state, ...payload }

    case 'UPDATE_AUTORIZACION_KEY':
      const newData = { ...state, ...payload }
      sessionStorage.setItem('autorizacion', JSON.stringify(newData))
      return newData

    case 'EMPTY_AUTORIZACION_SS':
      sessionStorage.removeItem('autorizacion')
      return defaultState

    case 'AUTORIZACION_FROM_SS':
      return { ...state, ...payload }

    default:
      return state
  }
}

export default autorizacionReducer
